/**
 * @generated SignedSource<<2e7bee3aeeeba1043182b873befd0145>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type TeeSheetHoleCountSelectorControl_facility$data = {
  readonly courseLayouts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly enabled: boolean;
        readonly holeCount: HoleCount;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "TeeSheetHoleCountSelectorControl_facility";
};
export type TeeSheetHoleCountSelectorControl_facility$key = {
  readonly " $data"?: TeeSheetHoleCountSelectorControl_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeeSheetHoleCountSelectorControl_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeeSheetHoleCountSelectorControl_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CourseLayoutConnection",
      "kind": "LinkedField",
      "name": "courseLayouts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseLayoutEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseLayout",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enabled",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "holeCount",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "1b5d0fdb4988f655e3bf105d1df65ce3";

export default node;
